<form>
  <!-- Modal Header -->
  <div class="modal-header">
    <h2>Add EPF Loan Request</h2>
    <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()"></button>
  </div>
  <div class="modal-body">
    <div class="d-flex flex-column gap-2 mb-3">
      <mat-slide-toggle class="mat-slide-toggle-lg" [hideIcon]="true" color="primary" [(ngModel)]="isShared" name="isShared" (change)="isManualKeyIn = isShared" [disabled]="this.selectedProfile != undefined && selectedProfile.SharedProfileId != undefined"> Share Customer </mat-slide-toggle>
      <mat-slide-toggle class="mat-slide-toggle-lg" [hideIcon]="true" color="primary" [(ngModel)]="isManualElevate" name="isManualElevate" (change)="elevateConfirmation()"> Send Request to BOSS </mat-slide-toggle>
      @if (isManualElevate === true) {
        <mat-slide-toggle class="mat-slide-toggle-lg" [hideIcon]="true" color="primary" [(ngModel)]="isManualKeyIn" name="isManualKeyIn" (change)="manualKeyInConfirmation()" [disabled]="isShared == true"> Manual Key In </mat-slide-toggle>
      }
    </div>

    @if (EPFDate !== undefined && EPFAmount !== undefined && checkIfEPFDateOver() === false) {
      <app-epf-limit-information [previousEPFLoans]="previousEPFLoans" [isEPFExtra]="isEPFExtra" [epfDate]="EPFDate" [epfAmount]="EPFAmount" [epfLimitRuleSet]="enums.epfLimitList"> </app-epf-limit-information>
    }

    <mat-expansion-panel class="shadow-lg" (opened)="epfDetailsExpansionIsOpen = true" (closed)="epfDetailsExpansionIsOpen = false" [expanded]="epfDetailsExpansionIsOpen">
      <mat-expansion-panel-header>
        <mat-panel-title class="gap-2 justify-content-between">
          <h4 class="mb-0">EPF Customer Details</h4>
          @if (!invalidEPF()) {
            <h2 class="mb-0 text-success"><i class="fas fa-check-circle"></i></h2>
          }
        </mat-panel-title>
      </mat-expansion-panel-header>

      <form [formGroup]="epfFormGroup">
        <div class="d-flex justify-content-end align-items-right">
          <div class="dropdown d-inline ms-1" data-bs-toggle="tooltip" data-placement="top" title="Upload Customer EPF Docs">
            <button class="btn btn-dark dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fas fa-upload"></i>
            </button>
            <div class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
              <a class="dropdown-item" (click)="openUploadEPFSupportingDoc(enums.EPF_STATEMENT)">
                <i class="fas fa-chart-pie"></i> EPF Statement
                <i class="fas fa-check text-success" [ngClass]="{ 'd-none': hasEPFStatement === false }"></i>
              </a>
              <a class="dropdown-item" (click)="openUploadEPFSupportingDoc(enums.EPF_PROOF)">
                <i class="fas fa-video"></i> EPF Proof
                <i class="fas fa-check text-success" [ngClass]="{ 'd-none': hasEPFProof === false }"></i>
              </a>
              <a class="dropdown-item" (click)="openUploadEPFSupportingDoc(enums.ACKNOWLEDGEMENT)">
                <i class="fas fa-clipboard-check"></i> Acknowledgement
                <i class="fas fa-check text-success" [ngClass]="{ 'd-none': hasCustomerAcknowledgement === false }"></i>
              </a>
            </div>
          </div>
        </div>

        <div class="d-grid gap-3 my-3" style="grid-template-columns: repeat(2, 1fr)">
          <mat-form-field subscriptSizing="dynamic" class="w-100">
            <mat-label>EPF Date</mat-label>
            <input matInput [matDatepicker]="myDatepicker" formControlName="Date" placeholder="EPF Settlement Date" [min]="sharedService.getTodayDate()" [max]="sharedService.getMaxDateForEPF()" readonly />
            <mat-datepicker-toggle matSuffix [for]="myDatepicker" disabled="true"> </mat-datepicker-toggle>
            <mat-datepicker #myDatepicker name="date"></mat-datepicker>
          </mat-form-field>

          <mat-form-field subscriptSizing="dynamic" class="w-100">
            <mat-label>EPF Amount (RM)</mat-label>
            <input matInput type="number" required placeholder="EPF Amount" formControlName="Amount" min="0" (keypress)="sharedService.isNumberKey($event)" [readonly]="epfDetails.Amount != undefined" />
          </mat-form-field>

          <mat-slide-toggle class="full-width-grid-item mat-slide-toggle-lg" [hideIcon]="true" color="primary" formControlName="HasIAccount"> Has iAccount </mat-slide-toggle>

          @if (updatingEPF.HasIAccount) {
            <mat-form-field subscriptSizing="dynamic" class="w-100">
              <mat-label>iAccount Username</mat-label>
              <input matInput type="text" placeholder="iAccount Username" formControlName="IAccountUsername" />
            </mat-form-field>
            <mat-form-field subscriptSizing="dynamic" class="w-100">
              <mat-label>iAccount Password</mat-label>
              <input matInput type="text" placeholder="iAccount Password" formControlName="IAccountPassword" />
            </mat-form-field>
          }

          <mat-form-field subscriptSizing="dynamic" class="w-100">
            <mat-label>Other ID (eg: Old IC )</mat-label>
            <input matInput type="text" placeholder="OtherID" formControlName="OtherId" />
          </mat-form-field>

          @if (this.selectedCustomer.Gender.length == 0) {
            <div class="form-floating">
              <select name="gender" class="form-select" formControlName="Gender">
                <option value="0" disabled selected hidden>SELECT A GENDER</option>
                @for (gender of enums.genderOptions; track gender) {
                  <option [value]="gender">{{ gender }}</option>
                }
              </select>
              <label for="gender">Gender</label>
            </div>
          }

          @if (this.selectedCustomer.Race.length == 0) {
            <div class="form-floating">
              <select name="race" class="form-select" formControlName="Race">
                <option value="" disabled selected hidden>SELECT A RACE</option>
                @for (race of enums.raceOptions; track race) {
                  <option [value]="race">{{ race }}</option>
                }
              </select>
              <label for="race">Race</label>
            </div>
          }
        </div>

        <div class="d-flex justify-content-end">
          <button class="btn btn-light" (click)="isEPFValid()">Next</button>
        </div>
      </form>
    </mat-expansion-panel>

    @if (epfDetailsExpansionIsOpen == false) {
      <mat-expansion-panel class="my-2" (opened)="guarantorExpansionIsOpen = true" (closed)="guarantorExpansionIsOpen = false; isGuarantorValid()" [expanded]="guarantorExpansionIsOpen">
        <mat-expansion-panel-header>
          <mat-panel-title class="gap-2 justify-content-between">
            <h4 class="mb-0">Gurantor Details</h4>
            @if (!invalidGuarantor()) {
              <h2 class="mb-0 text-success"><i class="fas fa-check-circle"></i></h2>
            }
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form>
          @if (contactList === undefined || contactList.length === 0) {
            <p>You do not have any contact can be chosen now, please add contact if necessary</p>
          }
          <div class="d-flex justify-content-end">
            <button class="btn btn-info" (click)="addContact()">Add</button>
          </div>
          @for (contact of contactList; track contact.ID; let i = $index) {
            <div class="my-2" [ngClass]="contact.IsSelected ? 'selectedContactCard' : 'contactCard'" (click)="toggleContactSelected(i)">
              <h5 class="m-3">Contact #{{ i + 1 }}</h5>
              <hr class="m-0" />
              <div class="d-flex gap-3 p-3">
                <i style="font-size: 1.5rem; color: purple" class="fas fa-check align-self-center" [ngClass]="{ invisible: !contact.IsSelected }"></i>
                <div class="flex-grow-1">
                  <div class="d-flex justify-content-between align-items-start mb-2">
                    @if (contact.PhotoExisted) {
                      <span class="badge text-bg-success">With Photos</span>
                    }
                    <div class="d-flex gap-2 ms-auto">
                      @if (sharedService.isRoles([enums.BOOKKEEPING_STAFF, enums.BRANCH_MANAGER, enums.STAFF])) {
                        <button appStopPropagation class="btn btn-dark dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <i class="fas fa-upload"></i>
                        </button>
                        <div class="dropdown-menu dropdown-menu-end">
                          <a appStopPropagation class="dropdown-item" (click)="openContactUploadFileDialog(contact, this.enums.CONTACT_GUARANTOR_FORM, i)">
                            <i class="fas fa-signature"></i> Guarantor Form
                            @if (contactFileExistence[contact.ID]?.includes(this.enums.CONTACT_GUARANTOR_FORM)) {
                              <i class="fas fa-check text-success"></i>
                            }
                          </a>
                          <a appStopPropagation class="dropdown-item" (click)="openContactUploadFileDialog(contact, this.enums.CONTACT_PROOF_OF_RELATION, i)">
                            <i class="far fa-heart"></i> Proof Of Relation
                            @if (contactFileExistence[contact.ID]?.includes(this.enums.CONTACT_PROOF_OF_RELATION)) {
                              <i class="fas fa-check text-success"></i>
                            }
                          </a>
                          <a appStopPropagation class="dropdown-item" (click)="openContactUploadFileDialog(contact, this.enums.CONTACT_ACKNOWLEDGEMENT, i)">
                            <i class="fas fa-clipboard-check"></i> Acknowledgement
                            @if (contactFileExistence[contact.ID]?.includes(this.enums.CONTACT_ACKNOWLEDGEMENT)) {
                              <i class="fas fa-check text-success"></i>
                            }
                          </a>
                          <a appStopPropagation class="dropdown-item" (click)="openContactUploadFileDialog(contact, this.enums.CONTACT_PHOTO, i)">
                            <i class="fas fa-photo-video"></i> Other Docs
                            @if (contact.PhotoExisted) {
                              <i class="fas fa-check text-success"></i>
                            }
                          </a>
                        </div>
                      }
                      <button class="btn btn-dark" (click)="openAddBankAccountModal(contact)">Add Account</button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">Name: {{ contact.Name }}</div>
                    <div class="col-md-6">IC Number: {{ contact.ICNumber }}</div>
                    <div class="col-md-6">Contact Number: {{ contact.ContactNumber }}</div>
                    <div class="col-md-6">Relation: {{ contact.Relation }}</div>
                  </div>
                </div>
              </div>
            </div>
          }
          <div class="d-flex justify-content-end align-items-right">
            <button class="btn btn-light" (click)="isGuarantorValid()">Next</button>
          </div>
        </form>
      </mat-expansion-panel>
    }

    @if (epfDetailsExpansionIsOpen === false && guarantorExpansionIsOpen === false) {
      <mat-expansion-panel class="my-2" (opened)="formJExpansionIsOpen = true" (closed)="formJExpansionIsOpen = false; isFormJSelected()" [expanded]="formJExpansionIsOpen">
        <mat-expansion-panel-header>
          <mat-panel-title class="gap-2 justify-content-between">
            <h4 class="mb-0">Form J Details</h4>
            @if (selectedFormJ !== undefined) {
              <h2 class="mb-0 text-success"><i class="fas fa-check-circle"></i></h2>
            }
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <div class="d-flex justify-content-end">
            <button class="btn btn-info" (click)="addFormJ()">Add</button>
          </div>
          @if (formJList?.length > 0) {
            <table class="table table-bordered my-2">
              <thead>
                <tr>
                  <th></th>
                  <th>Generated Date</th>
                  <th>Principal Amount</th>
                  <th>Extra Information</th>
                </tr>
              </thead>
              <tbody>
                @for (formJ of formJList; track formJ.Id; let i = $index) {
                  <tr>
                    <td>
                      <div class="form-check">
                        <input type="checkbox" class="form-check-input" name="isEpf" (change)="selectFormJ($event, formJ.Id)" [checked]="this.selectedFormJ === formJ.Id" [disabled]="selectedFormJ && selectedFormJ !== formJ.Id" />
                      </div>
                    </td>
                    <td>{{ formJ.DateCreated | date: "dd-MM-yyyy" }}</td>
                    <td>{{ formJ.Principal }}</td>
                    <td>
                      <table class="table">
                        <thead>
                          <tr>
                            <th>Months</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (schedule of formJ.PaymentSchedule; track schedule) {
                            <tr>
                              <td>{{ schedule.monthsCount }}</td>
                              <td>{{ schedule.amount }}</td>
                            </tr>
                          }
                        </tbody>
                      </table>
                      <div class="d-grid" style="grid-template-columns: repeat(2, 1fr)">
                        <div>Terms : {{ formJ.Term }}</div>
                        <div>Last Payment: RM {{ formJ.LastPayment }}</div>
                        <div>Receipt Number: {{ formJ.ReceiptNumber }}</div>
                        <div>Form J Date: {{ formJ.Date | date: "dd-MM-yyyy" }}</div>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          } @else {
            <p>Form J is required, please add Form J if necessary</p>
          }
        </div>
      </mat-expansion-panel>
    }

    @if ((epfDetailsExpansionIsOpen === false && !invalidGuarantor() && selectedFormJ !== undefined) || mainLoanRequest !== undefined) {
      @if (mainLoanRequest === undefined) {
        <button class="btn btn-primary" (click)="openAddLoanModal()">Add main loan</button>
      } @else {
        @if (isShared == true) {
          <button class="btn btn-primary" (click)="createNewRequestObject()">Add share loan</button>
        }

        @if (handlingChargeSignal() === false) {
          <div class="text-danger"><b>Cannot get HANDLING CHARGE</b></div>
        }
        <div class="m-1 p-1" style="background-color: lightyellow">
          <span class="d-flex justify-content-end align-items-right" style="cursor: pointer; color: gray" (click)="deleteMainLoan()"> <i class="fas fa-times"></i></span>
          <p>{{ mainLoanRequest.companyName }} | Loan: RM {{ mainLoanRequest.request.LoanInfo.Principal | number: "1.0-2" }} | Settlement:RM {{ this.sharedService.calculateEPFSettlementAmountWithCharges(mainLoanRequest.request.LoanInfo) | number: "1.0-2" }} | On Hand: RM {{ this.sharedService.calculateTotalOnHand(mainLoanRequest.request.LoanInfo) | number: "1.0-2" }}</p>
          <button class="btn btn-info" (click)="openLoanDetailsModal(mainLoanRequest.request)">View Details</button>
        </div>
      }

      @for (addedRequest of requestList; track addedRequest; let i = $index) {
        @if (addedRequest.request !== undefined) {
          <div class="m-1 p-1" style="background-color: lightsteelblue">
            <span class="d-flex justify-content-end align-items-right" style="cursor: pointer; color: gray" (click)="deleteNewLoan(i)"><i class="fas fa-times"></i></span>
            <p>{{ addedRequest.companyName }} | Loan: RM {{ addedRequest.request.LoanInfo.Principal | number: "1.0-2" }} | Settlement:RM {{ this.sharedService.calculateEPFSettlementAmountWithCharges(addedRequest.request.LoanInfo) | number: "1.0-2" }} | On Hand: RM {{ this.sharedService.calculateTotalOnHand(addedRequest.request.LoanInfo) | number: "1.0-2" }}</p>
            <button class="btn btn-info" (click)="openLoanDetailsModal(addedRequest.request)">View Details</button>
          </div>
        } @else {
          <div class="col-12 pt-3">
            <div class="text-end" style="cursor: pointer; color: gray" (click)="deleteNewLoan(i)">
              <i class="fas fa-times"></i>
            </div>
            <app-search-company-by-uid (passEntry)="getSelectedCompany($event, i)"></app-search-company-by-uid>
            @if (requestList[i] !== undefined && requestList[i].companyName !== undefined) {
              <div class="card">
                <div class="card-body">
                  <p>
                    <b>Share with {{ requestList[i].companyName }}</b>
                  </p>
                  <button class="btn btn-primary" (click)="openAddLoanModal(i)">Add Loan</button>
                </div>
              </div>
            }
          </div>
        }
      }
    }
  </div>

  <div class="modal-footer">
    <button class="btn btn-warning" [disabled]="disabledSubmit || mainLoanRequest === undefined" (click)="submitLoanRequest()">Submit</button>
  </div>
</form>
